/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Group_StepInputs */

const en_cook_group_step = /** @type {(inputs: Cook_Group_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This step`)
};

const de_cook_group_step = /** @type {(inputs: Cook_Group_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Schritt`)
};

/**
* | output |
* | --- |
* | "This step" |
*
* @param {Cook_Group_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_group_step = /** @type {((inputs?: Cook_Group_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Group_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_group_step(inputs)
	return en_cook_group_step(inputs)
});